// npm
import * as turf from '@turf/turf';

// hooks
import { useGeospatial } from '@/vue3/hooks/geospatialHook';

export const useCursor = () => {
    const { translate } = useGeospatial();

    const lngLatConditionedOnGeom = (
        drawings: any,
        lngLat: any,
        isSnap: boolean,
        toolName: string,
    ) => {
        if (
            !isSnap ||
            (drawings?.features[0].geometry.coordinates.length && drawings?.features[0].geometry.coordinates[0].length >= 3)
        )
            return lngLat;

        //if snap mode

        const coordArr = drawings?.features[0].geometry.coordinates[0];

        if (toolName === 'Line Tool')
            return { lng: coordArr[0], lat: coordArr[1] };

        else if( ((coordArr||[])[0]||[]).length == 2){
            return { lng: coordArr[0][0], lat: coordArr[1][1] };
        }

        else {
            return lngLat;
        }
    };

    const handleMoveCursor = (mapbox, isSnap, toolName, lngLat): void => {
        const source = mapbox.map.getSource('create-cursor-point');

        if (!source) return;

        let feature = source._data;
        const centroid = turf.centroid(feature).geometry?.coordinates;

        const drawings = mapbox.draw.getAll();

        const { lng, lat } = lngLatConditionedOnGeom(
            drawings,
            lngLat,
            isSnap,
            toolName,
        );

        if (!centroid) {
            return;
        }

        feature = translate(feature, centroid, [lng, lat]);

        source.setData(feature);
    };

    return { handleMoveCursor };
};
